module.exports = __webpack_public_path__ + "static/img/Motn-MCS-P.8c95d4ca.jpg";